import { format } from 'date-fns';

export const formatRelativeTime = (date) => {
  if (!date) return '';
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return '';
  const diffMs = Date.now() - d;
  const diffMin = Math.floor(diffMs / 60000);
  const diffHr = Math.floor(diffMs / 3600000);
  const diffDay = Math.floor(diffMs / 86400000);
  if (diffMin < 1) return 'Just now';
  if (diffMin < 60) return `${diffMin} min ago`;
  if (diffHr < 24) return `${diffHr} hr${diffHr > 1 ? 's' : ''} ago`;
  if (diffDay === 1) return 'Yesterday';
  if (diffDay < 7) return `${diffDay} days ago`;
  const weeks = Math.floor(diffDay / 7);
  if (diffDay < 30) return `${weeks} week${weeks > 1 ? 's' : ''} ago`;
  const months = Math.floor(diffDay / 30);
  if (diffDay < 365) return `${months} month${months > 1 ? 's' : ''} ago`;
  const years = Math.floor(diffDay / 365);
  return `${years} year${years > 1 ? 's' : ''} ago`;
};

export const formatDate = (date, pattern = 'dd/MM/yyyy') => {
  if (!date) return '';
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return '';
  return format(d, pattern);
};

export const formatSize = (bytes) => {
  if (!bytes) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const truncate = (text, max, suffix = '…') => {
  if (!text || text.length <= max) return text ?? '';
  return text.slice(0, max).trimEnd() + suffix;
};
